/*
 * @Author: lishiqiao
 * @Date: 2022-03-01 10:07:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-04 16:28:45
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /******* 动保实时有效库存 *******/
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 10:11:57
     * @description: 获取仓库下拉
     * @param {*} params
     */
    getStoreHouseList(params) {
        const url = `/mdtDrugDataGroup/getGroupConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 10:13:29
     * @description: 获取动保下拉
     * @param {*} params
     */
    getDrugList(params) {
        const url = `/mdtDrugDataGroup/getDrugConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 10:15:59
     * @description: 动保实时有效库存列表
     * @param {*} params
     */
    getPageList(params) {
        const url = `/mdtDrugDataGroup/searchMdtDrugDataGroupList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 10:17:15
     * @description: 动保实时有效库存列表导出
     * @param {*} params
     */
    exportData(params) {
        const url = `/mdtDrugDataGroup/exportMdtDrugDataGroupList`;
        return Page.exportDatas(url, params)
    },

    /******************** 动保使用记录 ********************/

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:33:21
     * @description: 根据角色权限获取养殖场下拉列表
     * @param {*}
     */
    getBaseListsByUser() {
        const url = '/baseData/queryBaseDataListByRole';
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:35:39
     * @description: 获取基地区域接口
     * @param {*} baseId
     */
    queryBaseGroupList(baseId) {
        const url = '/baseGroup/queryBaseGroupList';
        return http.post(url, {
            baseId: baseId,
            groupFlag: 0,
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:38:17
     * @description: 获取区域塘口接口
     * @param {*} groupId
     */
    listDataPermissionBoxData(groupId) {
        const url = '/boxData/listDataPermissionBoxData/' + groupId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:52:59
     * @description: 获取动保类型
     * @param {*} orgId
     */
    getDrugTypeList(orgId) {
        const url = '/orgType/searchOrgTypeList';
        return http.post(url, {
            orgId: orgId,
            type: 'drugType'
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:59:54
     * @description: 获取汇总类型
     * @param {*}
     */
    getTotalType() {
        const url = '/fishUseMedicin/getGroupByTypeList';
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 15:00:52
     * @description: 动保使用记录分页
     * @param {*} params
     */
    getDrugUsePageList(params) {
        const url = '/fishUseMedicin/getFishUseMedicinListByPage';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 15:17:03
     * @description: 模板下载
     * @param {*} params
     */
    exportDrugUseData(params) {
        const url = `/fileDownload/downloadFile/drugMedicationImport`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 10:27:30
     * @description: 导入
     * @param {*} params
     */
    importExcel(params) {
        const url = '/fishUseMedicin/importDrugTable';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 10:30:47
     * @description: 动保使用记录导出
     * @param {*} params
     */
    exporDrugUsetData(params) {
        const url = `/fishUseMedicin/recordListExportTable`;
        return Page.exportDatas(url, params)
    },

    /******************** 动保进出存 ********************/

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 10:39:50
     * @description: 根据基地id获取分组列表(含角色权限控制) 获取仓库列表
     * @param {*} baseId
     * @param {*} groupFlag 0:区域，1：总仓，空：区域和总仓
     */
    getInOutStoreHouseList(baseId, groupFlag) {
        const url = '/baseGroup/queryBaseGroupList';
        return http.post(url, {
            baseId: baseId,
            groupFlag: groupFlag
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 10:44:12
     * @description: 根据基地id获取动保列表
     * @param {*} baseId
     */
    getMedicinalsList(baseId) {
        const url = '/drugInOutSave/getDrugListByBaseId/' + baseId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 10:46:37
     * @description: 获取动保进出存列表数据分页
     * @param {*} params
     */
    getDrugInOutPageList(params) {
        const url = '/drugInOutSave/getDrugIntoListMap';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 10:59:24
     * @description: 动保进出存导出
     * @param {*} params
     */
    exportDrugInOutData(params) {
        const url = '/drugInOutSave/getDrugInOutSaveExportTable';
        return Page.exportDatas(url, params)
    }
}